var map = {
	"./default-loyalty-labels.js": 592,
	"./es-mx/default-loyalty-labels.js": 593,
	"./es/default-loyalty-labels.js": 594,
	"./fr/default-loyalty-labels.js": 595,
	"./pt/default-loyalty-labels.js": 596
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 591;